function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.42818 5.00285C5.42818 4.98762 5.4331 4.97335 5.4331 4.96289C5.60309 1.38439 8.2266 1 9.3497 1H9.41159C10.8029 1.0295 13.169 1.5785 13.3282 4.96289C13.3269 4.97639 13.3285 4.99002 13.3331 5.00285C13.338 5.03805 13.6986 8.42815 12.0557 10.2179C11.7217 10.5737 11.3108 10.8538 10.8523 11.0384C10.3937 11.2229 9.89881 11.3072 9.40276 11.2854H9.35166C8.85551 11.308 8.36036 11.2239 7.90169 11.0394C7.44303 10.8548 7.03219 10.5743 6.69866 10.2179C5.07248 8.44147 5.42327 5.03234 5.42818 5.00285Z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5029 12.3684C13.7697 13.2504 15.1551 13.9177 16.6107 14.3464C17.7123 14.7693 17.8349 16.0393 17.8728 17.2022C17.8718 17.2447 17.8733 17.2872 17.8773 17.3296C17.8859 17.857 17.8527 18.3844 17.7781 18.9058C15.2041 20.3404 12.3387 21.059 9.44191 20.9963C6.54362 21.0533 3.67759 20.333 1.10122 18.8999C1.02424 18.3788 0.99105 17.8513 1.00206 17.3237C1.00206 17.2829 1.00656 17.242 1.00656 17.1963C1.03992 16.0295 1.16252 14.7654 2.26866 14.3405C3.72005 13.9105 5.10199 13.2454 6.36739 12.3684",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    stroke: "#8B949B",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.1701be42.svg";
export { ForwardRef as ReactComponent };